import React from 'react';
import { Box, Spinner, Text } from 'grommet';
const HitScopeVideoLoading = () => {
  return (
    <Box fill="horizontal" gap="small">
      <Spinner size="medium" message="Start Built-in Spinner Announcement" />
      <Text>Loading HitScope video...</Text>
    </Box>
  );
};

const NoHitScope = () => {
  return (
    <Box gap="medium" color="transparent" pad="medium">
      <Text size="large" weight={'bold'}>
        No HitScope...!
      </Text>
      <Text>
        HitScope is a summary of your team’s batted balls all in one highlight
        video!
      </Text>
    </Box>
  );
};

export { HitScopeVideoLoading, NoHitScope };
